import {Component, Vue} from "vue-property-decorator";
import {mapActions, mapGetters} from "vuex";
import gql from "graphql-tag";
import {AxiosInstance} from "axios";
import {HdsActions} from "@/store/modules/hds/actions";
import {AssetsServiceProfile, ServiceProfile} from "@/store/modules/hcs/serviceProfile/model";
import {ServiceImplementation} from "@/store/modules/hcs/serviceImplementation/model";
import {ServiceComponentModel} from "@/store/modules/hds/Model";

/**
 * サービスプロファイルと関連する要素のためのビュー
 */
export interface ServiceProfileView extends ServiceProfile {
  serviceImplementation: ServiceImplementation;
  commonServiceComponentModel: ServiceComponentModel;
  localServiceComponentModel: ServiceComponentModel;
}

/**
 * 他事業者のサービスプロファイルと関連する要素のためのビュー
 */
export interface AssetsServiceProfileView extends AssetsServiceProfile {
  commonServiceComponentModel: ServiceComponentModel;
}

@Component({
  computed: {
    ...mapGetters({
      _hcsClient: 'hcs/client',
    }),
  },
  methods: {
    ...mapActions({
      _gqlQuery: 'hds/gqlQuery',
    }),
  }
})
export default class extends Vue {
  /** hcs/hcsClient */
  readonly _hcsClient!: AxiosInstance;

  /** hds/gqlQuery */
  readonly _gqlQuery!: HdsActions['gqlQuery'];

  /**
   * サービスプロファイルを読み込みます
   *
   * @param serviceProfileId サービスプロファイルID
   */
  async loadServiceProfile(serviceProfileId: string): Promise<ServiceProfileView> {
    const {data: serviceProfile} = await this._hcsClient.get<ServiceProfile>(`/service_profiles/${serviceProfileId}`);
    // const {data: serviceImplementation} = await this._hcsClient.get<ServiceImplementation>(`/service_implementations/${serviceProfile.serviceImplementationId}`);
    const serviceImplementation = serviceProfile.serviceImplementation;
    const {commonServiceComponentModel, localServiceComponentModel} = await this._gqlQuery({
          query: gql`
              query FindServiceComponentModel(
                  $commonServiceComponentModelId: ID!,
                  $localServiceComponentModelId: ID!
              ) {
                  commonServiceComponentModel: serviceComponentModel(serviceComponentModelId: $commonServiceComponentModelId) {
                      id
                      name
                      description
                      dictionary {
                          id
                          name
                          description
                      }
                  }
                  localServiceComponentModel: serviceComponentModel(serviceComponentModelId: $localServiceComponentModelId) {
                      id
                      name
                      description
                      dictionary {
                          id
                          name
                          description
                      }
                  }
              }`,
        variables: {
          commonServiceComponentModelId: serviceProfile.serviceComponentModelId,
          localServiceComponentModelId: serviceImplementation.serviceComponentModelId
        }
      });

    return {
      ...serviceProfile,
      // serviceImplementation,
      commonServiceComponentModel,
      localServiceComponentModel
    };
  }

  /**
   * 他事業者のサービスプロファイルを読み込みます
   *
   * @param serviceProfileId サービスプロファイルID
   */
  async loadAssetsServiceProfile(serviceProfileId: string): Promise<AssetsServiceProfileView> {
    const {data: serviceProfile} = await this._hcsClient.get<ServiceProfile>(`/assets/service_profiles/${serviceProfileId}`);
    const {commonServiceComponentModel} = await this._gqlQuery({
        query: gql`
            query FindServiceComponentModel(
                $commonServiceComponentModelId: ID!
            ) {
                commonServiceComponentModel: serviceComponentModel(serviceComponentModelId: $commonServiceComponentModelId) {
                    id
                    name
                    description
                    dictionary {
                        id
                        name
                        description
                    }
                }
            }`,
      variables: {
        commonServiceComponentModelId: serviceProfile.serviceComponentModelId,
      }
    });

    return {
      ...serviceProfile,
      commonServiceComponentModel,
    };
  }
}
